import { ExternalLink } from "@/components/ExternalLink";
import i18n from "@/i18n";
import { Link } from "@heroui/link";
import { ColumnDef } from "@tanstack/react-table";
import { toWorkspacePath } from "@/features/Workspaces/workspaceRoutes";

// import { getAuditColumns } from "@/features/Audit/getAuditColumns";

export type C8StaticDatum = {
  id: number;
  name?: string;
  isin?: string;
  currency?: string;
  asset_class_1?: string;
  asset_class_2?: string;
  has_transactions?: boolean;
  has_time_series?: boolean;
};

export const porfolios_columns: ColumnDef<C8StaticDatum>[] = [
  { accessorKey: "id", header: "Id" },
  { accessorKey: "name", header: "Nom" },
  { accessorKey: "isin", header: "ISIN" },
  { accessorKey: "currency", header: "Devise" },
  { accessorKey: "asset_class_1", header: "Classe d'actifs" },
  { accessorKey: "asset_class_2", header: "Sous-classe d'actifs" },
  {
    id: "actions",
    cell: ({ row }) => {
      const hasTransactions = row.original.has_transactions;
      const hasTimeSeries = row.original.has_time_series;

      return (
        <div className="flex gap-11 justify-end">
          <div className="flex gap-3">
            <ExternalLink
              href={toWorkspacePath("/admin/c8/c8_transactions")}
              queryParams={{
                c8_static_data_id_equal: row.getValue("id"),
              }}
              className={`text-xs ${
                !hasTransactions ? "invisible pointer-events-none" : ""
              }`}
              underline="hover"
            >
              Transactions
            </ExternalLink>
            <ExternalLink
              href={toWorkspacePath("/admin/c8/c8_time_series")}
              queryParams={{
                c8_static_data_id_equal: row.getValue("id"),
              }}
              className={`text-xs ${
                !hasTimeSeries ? "invisible pointer-events-none" : ""
              }`}
              underline="hover"
            >
              Valorisations
            </ExternalLink>
          </div>
          <Link
            href={`${window.location.pathname}/${row.getValue("id")}`}
            className="text-xs"
            underline="hover"
          >
            {i18n.t("actions.edit")}
          </Link>
        </div>
      );
    },
  },
];

// export const porfolios_audit_columns = getAuditColumns<C8StaticDatum>(porfolios_columns)</div>
